<template>
  <div class="is-flex is-justify-content-space-between is-flex-wrap-wrap">
    <div>
      <p class="has-text-weight-bold is-size-4">Aplicações</p>
      <p class="is-size-6">Faça aqui a gestão dos seus Goldylocks.</p>
    </div>
    <div>
      <!-- new Goldylocks link -->
      <a target="_blank" href="https://www.goldylocks.pt/registo/" class="button is-primary mt-3"> Criar nova</a>
    </div>
  </div>

  <!-- companies table -->
  <CompaniesTable :companies="companies"></CompaniesTable>
</template>

<script>
import CompaniesTable from "@/components/tables/CompaniesTable";

export default {
  name: "Companies",
  components: {CompaniesTable},
  computed: {
    companies() {
      return this.$store.getters.companies;
    }
  },
  mounted() {
    this.$store.dispatch('fetchCompanies');
  }
}
</script>

<style scoped>

</style>
